import { Component} from '@angular/core';
import { Product } from './../models/products/product.model';
import { ProductService } from './../services/product/product.service';
import { CategoryService } from './../services/category/category.service';
import { Category } from './../models/category/category.model';
import { DisplayCategory } from './../models/category/DisplayCategory.model';
import { Fields } from './../models/Fields/field-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpClient} from '@angular/common/http';
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'; 

import { DragulaService } from 'ng2-dragula';
import { RolePermissionService } from '../services/role/role-permission.service';
@Component({
  selector: 'cetogory-menu-management',
  templateUrl: './cetogory-menu-management.html',
  styleUrls: ['./cetogory-menu-management.css']
})
/** Create-Product component*/
export class CetogoryMenuComponent {

  //  public popoverTitle: string = 'Popover title';
  //  public popoverMessage: string = 'Popover description';
  //  public confirmClicked: boolean = false;
  //  public cancelClicked: boolean = false;

  product = new Product();
  public products: Product[] = [];
  public forecasts: any;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public displayCategory: DisplayCategory[];
  public cookieService: CookieService
  public parentCategoryList: Category[];
  public allCategoriesList: Category[];
  public ThirdLevelcategoryList: Category[];
  public SubcategoryList: Category[];
  public categryFields: Fields[];
  public inputElement: any;
  public specification: any;
  public shortDetail: any;
  public detail: any;
  public pId: number;
  public cId: number;
  public sId: number;

  public selectedPId: number;
  public selectedCId: number;
  public selectedSId: number;

  isShow: any;
  public SelectedCategory: string;
  public Parentname: string;
  public cName: string;


  fieldname: string;
  filename: string;
  excelFile: any;

  urls = new Array<string>();
  productID: number;
  public progress: number;
  public message: string;
  public parentid: number;
  public categoryid: number;

  constructor(private dragulaService: DragulaService, private readonly toastr: ToastsManager, private http: HttpClient, private readonly categoryService: CategoryService, private readonly productService: ProductService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    try {
      this.dragulaService.destroy("VAMPIRES");
    } catch (e) {
    }
    this.dragulaService.createGroup("VAMPIRES", {
    });
    this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
      args.sourceModel.forEach((item, index) => {
        item.sortOrder = index;
        this.allCategoriesList.forEach((v1, i1) => {
          if (v1.categoryID == item.categoryID) {
            v1.sortOrder = item.sortOrder;
            return false;
          }
        });
      });
    });

    this.rolePermissionService.GetRolePermissions("categorymenu").subscribe(
      data => { 
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
         
          if (list.length > 0) {
            this.product.isActive = true;
            this.product.inStock = true;
            this.filename = "nofile"
            this.product.isFeature = true;
            this.GetCategoryList();
            this.product.categoryID = null;
            this.selectedPId = 0;
            this.selectedCId = 0;
            this.selectedSId = 0; 
            

            try {
              this.dragulaService.destroy("VAMPIRESs");
            } catch (e) {
            }
            this.dragulaService.createGroup("VAMPIRESs", {

            }); 
            this.dragulaService.dropModel("VAMPIRESs").subscribe(args => {  
              args.sourceModel.forEach((item, index) => {
                item.sortOrder = index;
                this.allCategoriesList.forEach((v1, i1) => {
                  if (v1.categoryID == item.categoryID) {
                    v1.sortOrder = item.sortOrder;
                    return false;
                  }
                });
              });
            });

            try {
              this.dragulaService.destroy("VAMPIRESss");
            } catch (e) {
            }

            this.dragulaService.createGroup("VAMPIRESss", {

            }); 
            this.dragulaService.dropModel("VAMPIRESss").subscribe(args => {
              args.sourceModel.forEach((item, index) => { 
                item.sortOrder = index;
                this.allCategoriesList.forEach((v1, i1) => {
                  if (v1.categoryID == item.categoryID) {
                    v1.sortOrder = item.sortOrder;
                    return false;
                  }
                }); 
              }); 
            });

            this.pId = 0
            this.cId = 0
            this.sId = 0
            this.SelectedCategory = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  }

  GetCategoryList() {
    this.categoryService.GetAllCategoryList().subscribe(
      data => {
        this.allCategoriesList = data;
        this.allCategoriesList = this.allCategoriesList.filter(s => s.isActive == true);
        this.parentCategoryList = this.allCategoriesList.filter(s => s.parentCategoryID == 0).sort(x=>x.sortOrder);
        //this.SubcategoryList = this.allCategoriesList.filter(s => s.parentCategoryID > 0 && s.isParent == true);
        //this.ThirdLevelcategoryList = this.allCategoriesList.filter(s => s.isParent == false && s.parentCategoryID==);

        //this.GetCategoryListByParent(data[0].categoryID);
        //this.pId = data[0].categoryID;
        //this.Parentname = data[0].categoryName;
        //this.categryFields = [];

      }
    )
  } 

  GetCategoryListByParent(parentCategoryId: number) {
    this.SubcategoryList = this.allCategoriesList.filter(s => s.parentCategoryID == parentCategoryId).sort(x => x.sortOrder);
    this.ThirdLevelcategoryList = null;
      //this.GetSubCategoryListByParent(this.SubcategoryList[0].categoryID);
      //this.cId = this.SubcategoryList[0].categoryID;
      //this.cName = this.SubcategoryList[0].categoryName;
      this.selectedPId = parentCategoryId;
  }

  GetSubCategoryListByParent(parentCategoryId: number) {
    this.ThirdLevelcategoryList = this.allCategoriesList.filter(s => s.parentCategoryID == parentCategoryId).sort(x => x.sortOrder);
    this.selectedCId = parentCategoryId;
  }


  onChange(id: any) {
    let index = this.allCategoriesList.findIndex(item => item.id == id);
    this.allCategoriesList[index].isShow = !this.allCategoriesList[index].isShow;//true ? false : true; 

  }

  ResetAll() {
    this.allCategoriesList = null;
    this.parentCategoryList = null;
    this.SubcategoryList = null;
    this.ThirdLevelcategoryList = null;  
    this.GetCategoryList(); 
  }

  ngSubmit() {
    var ans = confirm("Are you sure to commit your changes");
    if (ans) {
    
      this.categoryService.UpdateCategoriesList(this.allCategoriesList).subscribe(
        data => { 
          if (data) {  
            this.toastr.success('Category Menu has been updated', '');
            setTimeout(() => {
              this.GetCategoryList();
            }, 500);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
  } 
}



// WEBPACK FOOTER //
// ./src/app/cetogory-menu-management/cetogory-menu-management.ts